// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partsDrop:hover {
  background-color: lightgray !important;
}

.partsDrop {
  padding: 5px;
  margin: 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  background-color: #f9f9f9;
}

.partsDrop:hover {
  background-color: #e0e0e0;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/dataTable/DataTable.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".partsDrop:hover {\n  background-color: lightgray !important;\n}\n\n.partsDrop {\n  padding: 5px;\n  margin: 5px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  background-color: #f9f9f9;\n}\n\n.partsDrop:hover {\n  background-color: #e0e0e0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
